import React from "react"
import { StyledSticker } from "./styled"

export default function Sticker(props) {
    return (
        <StyledSticker src={props.src} {...props} />
    )
}